/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_View_DescriptionInputs */

const es_feedback_modal_view_description = /** @type {(inputs: Feedback_Modal_View_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualiza la información enviada.`)
};

const en_feedback_modal_view_description = /** @type {(inputs: Feedback_Modal_View_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View the submitted information.`)
};

/**
* | output |
* | --- |
* | "View the submitted information." |
*
* @param {Feedback_Modal_View_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_view_description = /** @type {((inputs?: Feedback_Modal_View_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_View_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_view_description(inputs)
	return en_feedback_modal_view_description(inputs)
});
export { feedback_modal_view_description as "feedback.modal.view_description" }